import { sendMQTTMessage, parseMqttResult } from '../helper'
import { IMQTTRes } from '../type'

export async function getBackerStatus (): Promise<[boolean, boolean]> {
  return sendMQTTMessage<IMQTTRes<{
    backer_upload_status: 'running' | 'paused'
  }>>('xl_shell', 'get_backer_upload_status')
    .then(parseMqttResult)
    .then(res => {
      let uploadStatus = true
      let downloadStatus = false
      if (res.ret === 0) {
        const { backer_upload_status, backer_download_status } = res.result
        uploadStatus = backer_upload_status === 'running'
        downloadStatus = backer_download_status === 'running'
      }
      return [uploadStatus, downloadStatus] as [boolean, boolean]
    })
}
  
export function turnOnBackerService () {
  return sendMQTTMessage('xl_shell', 'start_backer_upload')
}
  
export function turnOffBackerService () {
  return sendMQTTMessage('xl_shell', 'stop_backer_upload')
}
  
export function turnOnRestoreService () {
  return sendMQTTMessage('xl_shell', 'enable_restore')
}
  
  
export interface TTransportConfig {
  'concurrent_downloads': number
  'upload_speed_limit': number
  'download_speed_limit': number
  'downloads_directory': string
}
  
export function setTransportSettings (params: TTransportConfig) {
  return sendMQTTMessage('xl_shell', 'set_transport_settings', params)
    .then(parseMqttResult)
}
  
export function getTransportSettings (): Promise<IMQTTRes<TTransportConfig>> {
  return sendMQTTMessage<IMQTTRes<TTransportConfig>>('xl_shell', 'get_transport_settings')
    .then(parseMqttResult)
}
  
export function turnOnThumbService () {
  return sendMQTTMessage('xl_shell', 'start_thumb')
    .then(parseMqttResult)
}
  
export function turnOffThumbService () {
  return sendMQTTMessage('xl_shell', 'stop_thumb')
    .then(parseMqttResult)
}
  
export function enableAutoRunThumb () {
  return sendMQTTMessage('xl_shell', 'enable_thumb')
    .then(parseMqttResult)
}
  
export function disableAutoRunThumb () {
  return sendMQTTMessage('xl_shell', 'disable_thumb')
    .then(parseMqttResult)
}
  
interface IThumbServiceStatus {
  /** 是否开启服务 */
  status: boolean
  /** 是否开机自启动 */
  enabled: boolean
}
interface IGetThumbStatusReply {
  ext_data: IThumbServiceStatus | null
}
interface IServiceSetting {
  status: 'running' | 'stopped'
  enabled: boolean
}
  
export async function getThumbStatus () {
  return sendMQTTMessage<IMQTTRes<IGetThumbStatusReply>>('xl_shell', 'get_thumb_status')
    .then(data => {
      const res = parseMqttResult<IGetThumbStatusReply>(data)
      const { ext_data } = res.result
      if (!ext_data) throw new Error('状态为空')
      const setting: IServiceSetting = {
        status: ext_data.status ? 'running' : 'stopped',
        enabled: ext_data.enabled,
      }
      return setting
    })
}
  
export async function deleteBackups () {
  return sendMQTTMessage<IMQTTRes<IGetThumbStatusReply>>('xl_shell', 'delete_backups')
    .then(parseMqttResult)
}